import { Model } from '@/clients/http'

import { CourierHttpParams, CourierResponses } from '@/types'

export class SteadfastModel extends Model {
  public static readonly correlations = {
    CREATE_PARCEL: 'CREATE_STEADFAST_PARCEL',
    TRACK_PARCEL: 'TRACK_STEADFAST_PARCEL',
    CANCEL_PARCEL: 'CANCEL_STEADFAST_PARCEL',
  }

  public static readonly endpoints = {
    createParcel: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/steadfast/create-parcel',
      }),

    trackParcel: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/steadfast/track-parcel',
      }),

    cancelParcel: () =>
      this.createEndpoint({
        url: '/api/backoffice/courier/steadfast/cancel-parcel',
      }),
  }

  public static readonly createParcel = async (props: CourierHttpParams.CreateSteadfastParcel) => {
    return this.createHttpRequest<
      CourierResponses.CreateSteadfastParcel,
      CourierResponses.CreateSteadfastParcelError
    >({
      correlationKey: this.correlations.CREATE_PARCEL,
      payload: {
        method: 'post',
        url: this.endpoints.createParcel(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly trackParcel = async (props: CourierHttpParams.TrackSteadfastParcel) => {
    return this.createHttpRequest<
      CourierResponses.TrackSteadfastParcel,
      CourierResponses.TrackSteadfastParcelError
    >({
      correlationKey: this.correlations.TRACK_PARCEL,
      payload: {
        method: 'post',
        url: this.endpoints.trackParcel(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly cancelParcel = async (props: CourierHttpParams.CancelSteadfastParcel) => {
    return this.createHttpRequest<
      CourierResponses.CancelSteadfastParcel,
      CourierResponses.CancelSteadfastParcelError
    >({
      correlationKey: this.correlations.CANCEL_PARCEL,
      payload: {
        method: 'post',
        url: this.endpoints.cancelParcel(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
